import {useRef, PropsWithChildren} from "react";
import {SnackbarProvider, closeSnackbar} from "notistack";
import CloseIcon from '@mui/icons-material/Close';
import IconButton from "@mui/material/IconButton";

const ToastProvider = ({children}: PropsWithChildren) => {
    const notistackRef = useRef<SnackbarProvider>(null);

    return (
        <SnackbarProvider
            ref={notistackRef}
            maxSnack={2}
            anchorOrigin={{vertical: "top", horizontal: "center"}}
            action={(snackbarId) => (
                <IconButton onClick={() => closeSnackbar(snackbarId)}>
                    <CloseIcon/>
                </IconButton>
            )}
        >
            {children}
        </SnackbarProvider>
    );
};

export default ToastProvider;